function countdown(): {
  time: number;
  interval: number | null;
  formattedTime: string;
  hours: number;
  minutes: number;
  seconds: number;
  isPrePromotion: boolean;
  promotionStartDate: Date;
  promotionEndDate: Date;
  isPromotionEnded: boolean;
  start: () => void;
  reset: () => void;
  formatNumber: (num: number) => string;
} {
  return {
    time: 0, // Time in seconds
    interval: null,
    isPrePromotion: true,
    promotionStartDate: new Date("2025-01-29T11:00:00Z"),
    promotionEndDate: new Date("2025-02-06T21:59:59Z"),
    isPromotionEnded: false,

    get formattedTime() {
      const hours = Math.floor(this.time / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((this.time % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.time % 60).toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
    get hours() {
      return Math.floor(this.time / 3600);
    },
    get minutes() {
      return Math.floor((this.time % 3600) / 60);
    },
    get seconds() {
      return this.time % 60;
    },
    formatNumber: (num) => {
      return num.toString().padStart(2, "0");
    },
    async start() {
      window.promotionStartDate = this.promotionStartDate;
      // try {
      //   const r = await fetch('https://samsungconfig.gcraft.tech/api/promotions').then((res) => res.json());
      //   console.log(r);
      //   this.promotionStartDate = new Date(r.promotionStartDate + 'Z');
      //   this.promotionEndDate = new Date(r.promotionEndDate + 'Z');
      // } catch (error) {
      //   console.error(error);
      // }

      this.isPrePromotion = new Date() < this.promotionStartDate;
      window.promotionStartDate = this.promotionStartDate;
      console.log(this.isPrePromotion);
      console.log(this.promotionStartDate, new Date());
      setTimeout(() => {
        this.isPrePromotion = false;
      }, this.promotionStartDate.getTime() - new Date().getTime());
      this.isPromotionEnded = new Date() > this.promotionEndDate;
      setTimeout(() => {
        this.isPromotionEnded = true;
      }, this.promotionEndDate.getTime() - new Date().getTime());

      this.time = Math.floor(
        (this.promotionEndDate.getTime() - new Date().getTime()) / 1000,
      );
      this.interval = setInterval(() => {
        if (this.time > 0) {
          if (this.time === 1) {
            this.isPromotionEnded = true;
          }
          this.time--;
        } else {
          clearInterval(this.interval || 0); // Stop when it reaches 0
        }
      }, 1000);
    },
    reset() {
      clearInterval(this.interval || 0);
      this.start();
    },
  };
}
if (typeof window !== "undefined") {
  (window as any).countdown = countdown;
}
